import { Button } from 'antd'

const TextBtn = props => {
  const { children, ...rest } = props
  return (
    <Button type="text" style={{ color: 'var(--theme-color)' }} {...rest}>
      {children}
    </Button>
  )
}

export default TextBtn
